import { useState } from "react";
import { hueOf } from "./content-types";

const assetHost = () => process.env.REACT_APP_DEV_URL || document.location.origin;

/**
 * LF360-2030 — a result's picture: its image when it has one (and it loads),
 * otherwise a tile with a letter — in the item's own colour (a FitFact's), or
 * one picked from its name.
 */
export const Thumbnail = ({ thumbnail, size = 40 }) => {
  const [broken, setBroken] = useState(false);

  if (thumbnail.imageUrl && !broken) {
    return (
      <img
        className="lf-cs-thumb lf-cs-thumb--image"
        style={{ width: size, height: size }}
        src={thumbnail.imageUrl}
        alt=""
        loading="lazy"
        onError={() => setBroken(true)}
      />
    );
  }

  const colours = thumbnail.color
    ? { background: thumbnail.color, color: "#fff" }
    : { background: `hsl(${thumbnail.hue} 60% 92%)`, color: `hsl(${thumbnail.hue} 45% 35%)` };

  return (
    <span
      className="lf-cs-thumb"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38), ...colours }}
    >
      {thumbnail.letter}
    </span>
  );
};

/** An article the task already holds, drawn like a search result's picture. */
export const ArticleThumbnail = ({ page, size = 32 }) => {
  const name = page.Category?.name || page.category?.name || page.title || "";

  return (
    <Thumbnail
      size={size}
      thumbnail={{
        imageUrl: `${assetHost()}/api/v1/pages/${page.id}/icon-mini`,
        letter: (String(name).trim()[0] || "?").toUpperCase(),
        hue: hueOf(name),
      }}
    />
  );
};
